import { Check, Clock, LucideIcon, Tag } from 'lucide-react';
import { StatusTone } from '@/components/ui/statusTone.ts';
import { PromoCodeStatus } from '@/features/public/booking/types/PromoCodeStatus.ts';

const promoCodeStatusLabels: Record<PromoCodeStatus, string> = {
  [PromoCodeStatus.APPLIED]: 'naliczony',
  [PromoCodeStatus.DEFERRED]: 'naliczy się po uzupełnieniu danych',
  [PromoCodeStatus.NOT_APPLIED]: 'niezastosowany',
};

export const getPromoCodeStatusLabel = (status: PromoCodeStatus): string =>
  promoCodeStatusLabels[status] ?? status;

export const promoCodeStatusTones: Record<PromoCodeStatus, StatusTone> = {
  [PromoCodeStatus.APPLIED]: 'success',
  [PromoCodeStatus.DEFERRED]: 'warning',
  [PromoCodeStatus.NOT_APPLIED]: 'error',
};

export const promoCodeStatusIcons: Record<PromoCodeStatus, LucideIcon> = {
  [PromoCodeStatus.APPLIED]: Check,
  [PromoCodeStatus.DEFERRED]: Clock,
  [PromoCodeStatus.NOT_APPLIED]: Tag,
};
